var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHistory(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.62143 1.00956C7.85835 -0.0798703 10.4211 -0.29627 12.809 0.402633C15.1969 1.10154 17.2385 2.66554 18.535 4.78914C19.8316 6.91275 20.2898 9.44342 19.8204 11.8868C19.3509 14.3302 17.9874 16.5109 15.9963 18.0028C14.0051 19.4947 11.5292 20.1908 9.05232 19.955C6.57542 19.7192 4.27538 18.5685 2.60146 16.7277C0.927546 14.8869 -2.38419e-07 12.4881 0 10H1C1 12.2393 1.83479 14.3982 3.34131 16.0549C4.84784 17.7117 6.91788 18.7473 9.14709 18.9595C11.3763 19.1717 13.6046 18.5453 15.3966 17.2025C17.1887 15.8598 18.4158 13.8972 18.8383 11.6981C19.2609 9.49908 18.8484 7.22148 17.6815 5.31023C16.5147 3.39899 14.6772 1.99138 12.5281 1.36237C10.3789 0.733358 8.07251 0.928118 6.05929 1.90861C4.04606 2.8891 2.47067 4.58489 1.64082 6.66474L0.712017 6.29415C1.63407 3.98321 3.38452 2.099 5.62143 1.00956Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 6.00001V1.00001H0V7.00001H6V6.00001H1Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 5.25001H10V10.724L13.5665 13.176L12.4335 14.8241L8 11.776V5.25001Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/History.e4272abccbd19f0b1e61e98ffde14d45.svg";
export { ForwardRef as ReactComponent };